import { Dialog } from 'primereact/dialog';

import { useConfigColumn } from '../../Hooks/Features/Pocker/useConfigColumn';
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';

const ConfigColumn = ({ configColumnPopup, setConfigColumnPopup, getWeightMetricsFormula }) => {
    const { columns, newCol, upsertDynamicColumn, rowData, handleChange } = useConfigColumn({ getWeightMetricsFormula, configColumnPopup });

    return (
        <Dialog
            visible={configColumnPopup?.visible}
            onHide={() => setConfigColumnPopup((prev) => ({ ...prev, visible: false }))}
            header="Columns Configuration"
            style={{ width: "50vw" }}
            draggable={false}
        >
            <div>
                <div className=" border rounded shadow-sm mb-4">
                    <div className="p-2 bg-light fw-bold">Add Dynamic Column</div>
                    <div className="p-3">
                        <div className="row g-3 align-items-end">
                            <div className="col-md-3">
                                <label className=" fw-semibold mb-1">Label Name</label><br></br>
                                <input
                                    type="text"
                                    className="sk-input-dd w100"
                                    placeholder="e.g., Raw Score"
                                    name='column_display_name'
                                    value={newCol?.column_display_name}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className=" fw-semibold mb-1">Formula</label><br></br>
                                <input
                                    type="text"
                                    className="sk-input-dd w100"
                                    placeholder="=Complexity Weight*Longevity Weight"
                                    name='column_expression'
                                    value={newCol?.column_expression}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 col-6 d-flex gap-4 mb-2 d-flex  justify-content-end align-items-center">
                                <input
                                    type="checkbox"
                                    name='is_active'
                                    checked={newCol?.is_active}
                                    onChange={handleChange}
                                />
                                <label className=" fw-semibold d-block">Active</label>
                                <button className="sk-btn text-white bg-black sk-btn-primary px-4" onClick={upsertDynamicColumn}>
                                    <i className="srkay-add me-1"></i> Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <small className=" px-3" >
                        <span className=" fw-bold mb-2 ">Note:</span> Special characters (like brackets, parens, or @) are not allowed in the formula variable names.
                    </small>
                </div>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <CommonGrid
                        columns={columns}
                        data={[{ title: "", id: "all", children: rowData }]}
                        expandAll={true}
                        strippedTable={true}
                        rowHeight={40}
                    />
                </div>

            </div>
        </Dialog>
    );
}

export default ConfigColumn;